import React from 'react'
import { Row } from 'antd'
import { CanvasSlides } from 'components/KaraokeSlides'
import './styles.scss'
import { BIG_CANVAS_PROPS } from 'constans/konva'


export const FinishedView = () => {
  return (
    <Row className='karaoke-finished container'>
      <CanvasSlides width={BIG_CANVAS_PROPS.width} height={BIG_CANVAS_PROPS.height} />
    </Row>
  )
}
